var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grey lighten-3 pa-4 greyContainer"},[(_vm.user.permissions.pass || _vm.user.permissions.passRead ||
                                 _vm.user.permissions.classic || _vm.user.permissions.bowling)?_c('spieler-export-filter',{attrs:{"level":"pass"}}):_c('v-alert',{attrs:{"text":"","color":"error","icon":"mdi-information"}},[_vm._v(" Du hast leider keine Berechtigung für diesen Bereich! ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }